export default __webpack_public_path__ + "static/media/main_section20.dc5e1058.jpg";